
import React from "react";
import { Dumbbell } from "lucide-react";

interface ProgramDetailsSectionProps {
  programData: any;
  aiContext?: any;
}

export default function ProgramDetailsSection({ programData, aiContext }: ProgramDetailsSectionProps) {
  if (!programData) return null;
  
  // Extract training frequency
  const trainingFrequency = programData.trainingFrequency || {};
  const daysPerWeek = trainingFrequency.daysPerWeek || programData.frequency || programData.daysPerWeek || 'Not specified';
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white/90 flex items-center gap-2 border-b border-white/20 pb-2">
        <Dumbbell className="h-5 w-5" />
        Program Details
      </h3>
      
      <div className="space-y-3">
        <div className="flex">
          <span className="text-white/80 w-40">Program Name:</span>
          <span className="text-white">{programData.name}</span>
        </div>
        <div className="flex">
          <span className="text-white/80 w-40">Duration:</span>
          <span className="text-white">{programData.duration} weeks</span>
        </div>
        <div className="flex">
          <span className="text-white/80 w-40">Tier:</span>
          <span className="text-white">{programData.tier}</span>
        </div>
        <div className="flex">
          <span className="text-white/80 w-40">Days Per Week:</span>
          <span className="text-white">{daysPerWeek} days/week</span>
        </div>
        
        {programData.description && (
          <div className="flex">
            <span className="text-white/80 w-40">Description:</span>
            <span className="text-white">{programData.description}</span>
          </div>
        )}
        
        {/* Medical Information Section */}
        {programData.medicalInfo && (
          <>
            {programData.medicalInfo.conditions && programData.medicalInfo.conditions.length > 0 && (
              <div className="flex">
                <span className="text-white/80 w-40">Medical Conditions:</span>
                <span className="text-white">{programData.medicalInfo.conditions.join(', ')}</span>
              </div>
            )}
            
            {programData.medicalInfo.injuries && programData.medicalInfo.injuries.length > 0 && (
              <div className="flex">
                <span className="text-white/80 w-40">Injuries:</span>
                <span className="text-white">{programData.medicalInfo.injuries.join(', ')}</span>
              </div>
            )}
            
            {programData.medicalInfo.medicalDetails && (
              <div className="flex">
                <span className="text-white/80 w-40">Medical Details:</span>
                <span className="text-white">{programData.medicalInfo.medicalDetails}</span>
              </div>
            )}
          </>
        )}
        
        {/* Legacy medical info display for backward compatibility */}
        {!programData.medicalInfo && (
          <>
            {programData.medicalConditions && (
              <div className="flex">
                <span className="text-white/80 w-40">Medical Conditions:</span>
                <span className="text-white">{programData.medicalConditions === "yes" ? "Yes" : "No"}</span>
              </div>
            )}
            
            {programData.medicalConditions === "yes" && programData.medicalDetails && (
              <div className="flex">
                <span className="text-white/80 w-40">Medical Details:</span>
                <span className="text-white">{programData.medicalDetails}</span>
              </div>
            )}
            
            {programData.injuries && (
              <div className="flex">
                <span className="text-white/80 w-40">Injuries:</span>
                <span className="text-white">{programData.injuries}</span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
